import { Badge, Skeleton } from '@radix-ui/themes';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import { fromCategoryToClass } from 'helpers/ranks';
import type { Category } from 'types/player';

export const AgeCategoryLabel: React.FC<{
  ageCategory?: Category;
  linkTo?: boolean;
  className?: string;
  loading?: boolean;
  stretch?: boolean;
}> = ({ ageCategory, linkTo = false, className, loading = false, stretch = false }) => {
  const content = (
    <Skeleton loading={loading} className='h-8 w-16'>
      <Badge
        className={classNames(
          { 'min-w-0': stretch },
          { 'min-w-11': !stretch },
          'rounded-sm',
          'text-neutral-neutral-1',
          'border',
          'border-solid',
          'border-neutral-neutral-alpha-7',
          'justify-center',
          className,
          fromCategoryToClass(ageCategory!),
        )}
      >
        {ageCategory ? ageCategory : ' - '}
      </Badge>
    </Skeleton>
  );
  return linkTo && ageCategory ? (
    <Link
      to={{
        pathname: '/classifiche',
        search: `?category=${ageCategory}`,
      }}
    >
      {content}
    </Link>
  ) : (
    content
  );
};

export default AgeCategoryLabel;
